import { render, staticRenderFns } from "./KnowledgeCenterList.vue?vue&type=template&id=1633eca6&"
import script from "./KnowledgeCenterList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports